// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"7ea1e664","359":"4b799450","401":"af5b56ff","406":"f6708c27","488":"bc560535","617":"2d4cc993","772":"3109d593","949":"e972ff5d","950":"86de99b7"}[chunkId] + ".chunk.js";
};